var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2H10L9.76846 4.31538C9.19837 4.48064 8.6545 4.70762 8.14458 4.98862L6.34315 3.51472L3.51472 6.34315L4.98862 8.14458C4.70762 8.6545 4.48064 9.19837 4.31538 9.76846L2 10V14L4.31538 14.2315C4.48064 14.8016 4.70762 15.3455 4.98862 15.8554L3.51472 17.6569L6.34315 20.4853L8.14458 19.0114C8.6545 19.2924 9.19837 19.5194 9.76846 19.6846L10 22H14L14.2315 19.6846C14.8016 19.5194 15.3455 19.2924 15.8554 19.0114L17.6569 20.4853L20.4853 17.6569L19.0114 15.8554C19.2924 15.3455 19.5194 14.8016 19.6846 14.2315L22 14V10L19.6846 9.76846C19.5194 9.19837 19.2924 8.6545 19.0114 8.14458L20.4853 6.34315L17.6569 3.51472L15.8554 4.98862C15.3455 4.70762 14.8016 4.48064 14.2315 4.31538L14 2Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings24);
export default __webpack_public_path__ + "static/media/settings-24.524b063a71d5fab6d1e832393ff77ac5.svg";
export { ForwardRef as ReactComponent };